export default __webpack_public_path__ + "apply12a42af.png";